const editorMessages = {
    "en": {
        "gui.alerts.lostPeripheralConnection": "Scratch lost connection to {extensionName}.",
        "gui.alerts.tryAgain": "Try Again",
        "gui.alerts.download": "Download",
        "gui.connection.reconnect": "Reconnect",
        "gui.backpack.costumeLabel": "costume",
        "gui.backpack.soundLabel": "sound",
        "gui.backpack.scriptLabel": "script",
        "gui.backpack.spriteLabel": "sprite",
        "gui.backpack.header": "Backpack",
        "gui.backpack.errorBackpack": "Error loading backpack",
        "gui.backpack.loadingBackpack": "Loading...",
        "gui.backpack.more": "More",
        "gui.backpack.emptyBackpack": "Backpack is empty",
        "gui.unsupportedBrowser.label": "Browser is not supported",
        "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
        "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
        "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
        "gui.unsupportedBrowser.back": "Back",
        "gui.unsupportedBrowser.previewfaq": "To learn more, go to the {previewFaqLink}.",
        "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
        "gui.cards.all-tutorials": "Tutorials",
        "gui.cards.shrink": "Shrink",
        "gui.cards.expand": "Expand",
        "gui.cards.close": "Close",
        "gui.cards.more-things-to-try": "More things to try!",
        "gui.cards.see-more": "See more",
        "gui.comingSoon.message1": "Don't worry, we're on it {emoji}",
        "gui.comingSoon.message2": "Coming Soon...",
        "gui.comingSoon.message3": "We're working on it {emoji}",
        "gui.connection.auto-scanning.noPeripheralsFound": "No devices found",
        "gui.connection.auto-scanning.prescan": "Have your device nearby, then begin searching.",
        "gui.connection.auto-scanning.pressbutton": "Press the button on your device.",
        "gui.connection.auto-scanning.start-search": "Start Searching",
        "gui.connection.connecting-searchbutton": "Searching...",
        "gui.connection.auto-scanning.try-again": "Try again",
        "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
        "gui.connection.connected": "Connected",
        "gui.connection.disconnect": "Disconnect",
        "gui.connection.go-to-editor": "Go to Editor",
        "gui.connection.connecting-cancelbutton": "Connecting...",
        "gui.connection.error.errorMessage": "Oops, looks like something went wrong.",
        "gui.connection.error.tryagainbutton": "Try again",
        "gui.connection.error.helpbutton": "Help",
        "gui.connection.peripheral-name-label": "Device name",
        "gui.connection.connect": "Connect",
        "gui.connection.scanning.lookingforperipherals": "Looking for devices",
        "gui.connection.scanning.noPeripheralsFound": "No devices found",
        "gui.connection.scanning.instructions": "Select your device in the list above.",
        "gui.connection.search": "Refresh",
        "gui.connection.scanning.updatePeripheralButton": "Update my Device",
        "gui.connection.unavailable.installscratchlink": "Make sure you have Scratch Link installed and running",
        "gui.connection.unavailable.enablebluetooth": "Check that Bluetooth is enabled",
        "gui.connection.unavailable.tryagainbutton": "Try again",
        "gui.connection.unavailable.helpbutton": "Help",
        "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
        "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
        "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
        "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
        "gui.connection.updatePeripheral.updateFailed": "Update failed.",
        "gui.connection.updatePeripheral.goBackButton": "Go Back",
        "gui.connection.updatePeripheral.updateNowButton": "Do Update",
        "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
        "gui.controls.go": "Go",
        "gui.controls.stop": "Stop",
        "gui.crashMessage.label": "Oops! Something went wrong.",
        "gui.crashMessage.description": "We are so sorry, but it looks like Scratch has crashed. This bug has been automatically reported to the Scratch Team. Please refresh your page to try again.",
        "gui.crashMessage.errorNumber": "Your error was logged with id {errorId}",
        "gui.crashMessage.reload": "Reload",
        "gui.customProcedures.myblockModalTitle": "Make a Block",
        "gui.customProcedures.addAnInputNumberText": "Add an input",
        "gui.customProcedures.numberTextType": "number or text",
        "gui.customProcedures.addAnInputBoolean": "Add an input",
        "gui.customProcedures.booleanType": "boolean",
        "gui.customProcedures.addALabel": "Add a label",
        "gui.customProcedures.runWithoutScreenRefresh": "Run without screen refresh",
        "gui.customProcedures.cancel": "Cancel",
        "gui.customProcedures.ok": "OK",
        "gui.gui.shouldDeleteSprite": "Are you sure you want to delete this sprite?",
        "gui.gui.shouldDeleteCostume": "Are you sure you want to delete this costume?",
        "gui.gui.shouldDeleteSound": "Are you sure you want to delete this sound?",
        "gui.gui.confirm": "yes",
        "gui.gui.cancel": "no",
        "gui.gui.deleteAssetHeading": "Confirm Asset Deletion",
        "gui.SpriteInfo.direction": "Direction",
        "gui.directionPicker.rotationStyles.allAround": "All Around",
        "gui.directionPicker.rotationStyles.leftRight": "Left/Right",
        "gui.directionPicker.rotationStyles.dontRotate": "Do not rotate",
        "gui.gui.addExtension": "Add Extension",
        "gui.gui.codeTab": "Code",
        "gui.gui.backdropsTab": "Backdrops",
        "gui.gui.costumesTab": "Costumes",
        "gui.gui.soundsTab": "Sounds",
        "gui.extensionLibrary.comingSoon": "Coming Soon",
        "gui.extensionLibrary.requires": "Requires",
        "gui.extensionLibrary.collaboration": "Collaboration with",
        "gui.library.filterPlaceholder": "Search",
        "gui.library.allTag": "All",
        "gui.library.gettingStarted": "Getting Started",
        "gui.library.basics": "Basics",
        "gui.library.intermediate": "Intermediate",
        "gui.library.prompts": "Prompts",
        "gui.loader.message1": "Creating blocks …",
        "gui.loader.message2": "Loading sprites …",
        "gui.loader.message3": "Loading sounds …",
        "gui.loader.message4": "Loading extensions …",
        "gui.loader.message5": "Herding cats …",
        "gui.loader.message6": "Transmitting nanos …",
        "gui.loader.message7": "Inflating gobos …",
        "gui.loader.message8": "Preparing emojis …",
        "gui.loader.headline": "Loading Project",
        "gui.loader.creating": "Creating Project",
        "gui.accountMenu.profile": "Profile",
        "gui.accountMenu.myStuff": "My Stuff",
        "gui.accountMenu.myClasses": "My Classes",
        "gui.accountMenu.myClass": "My Class",
        "gui.accountMenu.accountSettings": "Account settings",
        "gui.accountMenu.signOut": "Sign out",
        "gui.authorInfo.byUser": "by {username}",
        "gui.menuBar.seeProjectPage": "See Project Page",
        "gui.menuBar.language": "Language",
        "general.username": "Username",
        "general.password": "Password",
        "general.signIn": "Sign in",
        "login.needHelp": "Need Help?",
        "form.validationRequired": "This field is required",
        "gui.menuBar.tutorialsLibrary": "Tutorials",
        "gui.menuBar.restoreSprite": "Restore Sprite",
        "gui.menuBar.restoreSound": "Restore Sound",
        "gui.menuBar.restoreCostume": "Restore Costume",
        "gui.menuBar.restore": "Restore",
        "gui.menuBar.saveNow": "Save now",
        "gui.menuBar.saveAsCopy": "Save as a copy",
        "gui.menuBar.remix": "Remix",
        "gui.menuBar.new": "New",
        "gui.menuBar.file": "File",
        "gui.menuBar.downloadToComputer": "Save to your computer",
        "gui.menuBar.edit": "Edit",
        "gui.menuBar.turboModeOff": "Turn off Turbo Mode",
        "gui.menuBar.turboModeOn": "Turn on Turbo Mode",
        "gui.menuBar.modeMenu": "Mode",
        "gui.menuBar.normalMode": "Normal mode",
        "gui.menuBar.caturdayMode": "Caturday mode",
        "gui.menuBar.joinScratch": "Join Scratch",
        "gui.menuBar.signIn": "Sign in",
        "gui.gui.projectTitlePlaceholder": "Project title here",
        "gui.menuBar.saveNowLink": "Save Now",
        "gui.menuBar.settings": "Settings",
        "gui.menuBar.isShared": "Shared",
        "gui.menuBar.share": "Share",
        "gui.menuBar.colorMode": "Color Mode",
        "gui.modal.help": "Help",
        "gui.modal.back": "Back",
        "gui.monitor.listMonitor.empty": "(empty)",
        "gui.monitor.listMonitor.listLength": "length {length}",
        "gui.monitor.contextMenu.default": "normal readout",
        "gui.monitor.contextMenu.large": "large readout",
        "gui.monitor.contextMenu.slider": "slider",
        "gui.monitor.contextMenu.sliderRange": "change slider range",
        "gui.monitor.contextMenu.import": "import",
        "gui.monitor.contextMenu.export": "export",
        "gui.monitor.contextMenu.hide": "hide",
        "gui.playButton.play": "Play",
        "gui.playButton.stop": "Stop",
        "gui.gui.variableScopeOptionAllSprites": "For all sprites",
        "gui.gui.variableScopeOptionSpriteOnly": "For this sprite only",
        "gui.gui.cloudVariableOption": "Cloud variable (stored on server)",
        "gui.gui.variablePromptAllSpritesMessage": "This variable will be available to all sprites.",
        "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
        "gui.prompt.cancel": "Cancel",
        "gui.prompt.ok": "OK",
        "gui.playbackStep.stopMsg": "Stop",
        "gui.playbackStep.playMsg": "Play",
        "gui.playbackStep.loadingMsg": "Loading...",
        "gui.playbackStep.saveMsg": "Save",
        "gui.playbackStep.reRecordMsg": "Re-record",
        "gui.recordModal.title": "Record Sound",
        "gui.recordingStep.beginRecord": "Begin recording by clicking the button below",
        "gui.recordingStep.permission": "{arrow}We need your permission to use your microphone",
        "gui.recordingStep.stop": "Stop recording",
        "gui.recordingStep.record": "Record",
        "gui.sliderModal.min": "Minimum value",
        "gui.sliderModal.max": "Maximum value",
        "gui.sliderModal.title": "Change slider range",
        "gui.sliderPrompt.cancel": "Cancel",
        "gui.sliderPrompt.ok": "OK",
        "gui.soundEditor.sound": "Sound",
        "gui.soundEditor.play": "Play",
        "gui.soundEditor.stop": "Stop",
        "gui.soundEditor.copy": "Copy",
        "gui.soundEditor.paste": "Paste",
        "gui.soundEditor.copyToNew": "Copy to New",
        "gui.soundEditor.delete": "Delete",
        "gui.soundEditor.save": "Save",
        "gui.soundEditor.undo": "Undo",
        "gui.soundEditor.redo": "Redo",
        "gui.soundEditor.faster": "Faster",
        "gui.soundEditor.slower": "Slower",
        "gui.soundEditor.echo": "Echo",
        "gui.soundEditor.robot": "Robot",
        "gui.soundEditor.louder": "Louder",
        "gui.soundEditor.softer": "Softer",
        "gui.soundEditor.reverse": "Reverse",
        "gui.soundEditor.fadeOut": "Fade out",
        "gui.soundEditor.fadeIn": "Fade in",
        "gui.soundEditor.mute": "Mute",
        "gui.SpriteInfo.spritePlaceholder": "Name",
        "gui.SpriteInfo.showSpriteAction": "Show sprite",
        "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
        "gui.SpriteInfo.sprite": "Sprite",
        "gui.SpriteInfo.show": "Show",
        "gui.SpriteInfo.size": "Size",
        "gui.spriteSelectorItem.contextMenuDuplicate": "duplicate",
        "gui.spriteSelectorItem.contextMenuExport": "export",
        "gui.spriteSelectorItem.contextMenuDelete": "delete",
        "gui.spriteSelector.addSpriteFromLibrary": "Choose a Sprite",
        "gui.spriteSelector.addSpriteFromPaint": "Paint",
        "gui.spriteSelector.addSpriteFromSurprise": "Surprise",
        "gui.spriteSelector.addSpriteFromFile": "Upload Sprite",
        "gui.stageHeader.stageSizeLarge": "Switch to large stage",
        "gui.stageHeader.stageSizeSmall": "Switch to small stage",
        "gui.stageHeader.stageSizeFull": "Enter full screen mode",
        "gui.stageHeader.stageSizeUnFull": "Exit full screen mode",
        "gui.stageHeader.fullscreenControl": "Full Screen Control",
        "gui.spriteSelector.addBackdropFromLibrary": "Choose a Backdrop",
        "gui.stageSelector.addBackdropFromPaint": "Paint",
        "gui.stageSelector.addBackdropFromSurprise": "Surprise",
        "gui.stageSelector.addBackdropFromFile": "Upload Backdrop",
        "gui.stageSelector.stage": "Stage",
        "gui.stageSelector.backdrops": "Backdrops",
        "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
        "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
        "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
        "gui.telemetryOptIn.privacyPolicyLink": "Privacy Policy",
        "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
        "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
        "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
        "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
        "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
        "gui.telemetryOptIn.buttonClose": "Close",
        "gui.turboMode.active": "Turbo Mode",
        "gui.webglModal.label": "Your Browser Does Not Support WebGL",
        "gui.webglModal.description": "Unfortunately it looks like your browser or computer {webGlLink}. This technology is needed for Scratch 3.0 to run.",
        "gui.webglModal.webgllink": "does not support WebGL",
        "gui.webglModal.back": "Back",
        "gui.webglModal.previewfaq": "To learn more, go to the {previewFaqLink}.",
        "gui.webglModal.previewfaqlinktext": "FAQ",
        "gui.costumeLibrary.chooseABackdrop": "Choose a Backdrop",
        "gui.costumeLibrary.chooseACostume": "Choose a Costume",
        "gui.costumeTab.addBackdropFromLibrary": "Choose a Backdrop",
        "gui.costumeTab.addCostumeFromLibrary": "Choose a Costume",
        "gui.costumeTab.addBlankCostume": "Paint",
        "gui.costumeTab.addSurpriseCostume": "Surprise",
        "gui.costumeTab.addFileBackdrop": "Upload Backdrop",
        "gui.costumeTab.addFileCostume": "Upload Costume",
        "gui.extensionLibrary.chooseAnExtension": "Choose an Extension",
        "gui.extensionLibrary.extensionUrl": "Enter the URL of the extension",
        "gui.monitors.importListColumnPrompt": "Which column should be used (1-{numberOfColumns})?",
        "gui.recordingStep.alertMsg": "Could not start recording",
        "gui.soundLibrary.chooseASound": "Choose a Sound",
        "gui.soundTab.fileUploadSound": "Upload Sound",
        "gui.soundTab.surpriseSound": "Surprise",
        "gui.soundTab.recordSound": "Record",
        "gui.soundTab.addSoundFromLibrary": "Choose a Sound",
        "gui.spriteLibrary.chooseASprite": "Choose a Sprite",
        "gui.tipsLibrary.tutorials": "Choose a Tutorial",
        "gui.alerts.createsuccess": "New project created.",
        "gui.alerts.createcopysuccess": "Project saved as a copy.",
        "gui.alerts.createremixsuccess": "Project saved as a remix.",
        "gui.alerts.creating": "Creating new…",
        "gui.alerts.creatingCopy": "Copying project…",
        "gui.alerts.creatingRemix": "Remixing project…",
        "gui.alerts.creatingError": "Could not create the project. Please try again!",
        "gui.alerts.savingError": "Project could not save.",
        "gui.alerts.savesuccess": "Project saved.",
        "gui.alerts.saving": "Saving project…",
        "gui.alerts.cloudInfo": "Please note, cloud variables only support numbers, not letters or symbols. {learnMoreLink}",
        "gui.alerts.cloudInfoLearnMore": "Learn more.",
        "gui.alerts.importing": "Importing…",
        "gui.defaultProject.meow": "Meow",
        "gui.defaultProject.variable": "my variable",
        "gui.howtos.intro-move-sayhello-hat.name": "Getting Started",
        "gui.howtos.intro-move.step_stepMove": "Add a move block",
        "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
        "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
        "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
        "gui.howtos.animate-a-name.name": "Animate a Name",
        "gui.howtos.animate-a-name.step_AnimatePickLetter": "Pick a Letter Sprite",
        "gui.howtos.animate-a-name.step_AnimatePlaySound": "Play a Sound When Clicked",
        "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Pick Another Letter Sprite",
        "gui.howtos.animate-a-name.step_AnimateChangeColor": "Change color",
        "gui.howtos.animate-a-name.step_AnimateSpin": "Pick Another Letter Sprite & Make It Spin",
        "gui.howtos.animate-a-name.step_AnimateGrow": "Pick Another Letter Sprite & Make It Grow",
        "gui.howtos.animate-char.name": "Animate A Character",
        "gui.howtos.animate-char.step_addbg": "Add a Backdrop",
        "gui.howtos.animate-char.step_addsprite": "Add a Sprite",
        "gui.howtos.animate-char.step_saysomething": "Say Something",
        "gui.howtos.animate-char.step_addsound": "Add Sound",
        "gui.howtos.animate-char.step_animatetalking": "Animate Talking",
        "gui.howtos.animate-char.step_arrowkeys": "Move Using Arrow Keys",
        "gui.howtos.animate-char.step_jump": "Jump",
        "gui.howtos.animate-char.step_changecolor": "Change Color",
        "gui.howtos.story.name": "Create A Story",
        "gui.howtos.story.step_addbg": "Add a Backdrop",
        "gui.howtos.story.step_addsprite": "Add a Character",
        "gui.howtos.story.step_saysomething": "Say Something",
        "gui.howtos.story.step_addanothersprite": "Add Another Character",
        "gui.howtos.story.step_flip": "Flip Direction",
        "gui.howtos.story.step_conversation": "Have A Conversation",
        "gui.howtos.story.addanotherbg": "Add Another Backdrop",
        "gui.howtos.story.step_swithbg": "Switch Backdrops",
        "gui.howtos.story.step_hidewizard": "Hide a Character",
        "gui.howtos.story.step_showwizard": "Show a Character",
        "gui.howtos.say-it-out-loud": "Create Animations That Talk",
        "gui.howtos.say-it-out-loud.step_AddTXTextension": "Add the Text to Speech blocks",
        "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
        "gui.howtos.say-it-out-loud_TXTSetVoice": "Set a Voice",
        "gui.howtos.say-it-out-loud.step_TXTMove": "Move Around",
        "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Add a Backdrop",
        "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Add Another Character",
        "gui.howtos.say-it-out-loud.step_TXTSong": "Perform a Song",
        "gui.howtos.say-it-out-loud.step_TXTColor": "Change Color",
        "gui.howtos.say-it-out-loud.step_TXTSpin": "Spin Around",
        "gui.howtos.say-it-out-loud.step_TXTGrow": "Grow and Shrink",
        "gui.howtos.imagine": "Imagine a World",
        "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
        "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
        "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
        "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
        "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
        "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
        "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
        "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
        "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
        "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
        "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
        "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
        "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
        "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
        "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
        "gui.howtos.add-effects.name": "Add Effects",
        "gui.howtos.videosens.step_addEffects": "Add Effects",
        "gui.howtos.make-it-fly.name": "Make it Fly",
        "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
        "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
        "gui.howtos.fly.step_stepflySaySomething": "Say Something",
        "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
        "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
        "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
        "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
        "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
        "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
        "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
        "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
        "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
        "gui.howtos.make-music.name": "Make Music",
        "gui.howtos.Make-Music.step_PickInstrument": "Pick an Instrument Sprite",
        "gui.howtos.Make-Music.step_PlaySoundClick": "Play Sound When Clicked",
        "gui.howtos.Make-Music.step_MakeSong": "Create a Song",
        "gui.howtos.make-music.step_MakeBeat": "Choose a Drum & Make a Beat",
        "gui.howtos.make-music.step_MakeBeatBox": "Choose the Microphone Sprite & Surprise Beatbox",
        "gui.howtos.pong": "Pong Game",
        "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
        "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
        "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
        "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
        "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
        "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
        "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
        "gui.howtos.pong.step_pongAddAScore": "Add a Score",
        "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
        "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
        "gui.howtos.pong.step_pongResetScore": "Reset Score",
        "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
        "gui.howtos.pong.step_pongGameOver": "Game Over",
        "gui.howtos.make-a-game.name": "Make a Clicker Game",
        "gui.howtos.Make-A-Game.step_GamePickSprite": "Pick A Sprite",
        "gui.howtos.make-a-game.step_GamePlaySound": "Play Sound When Clicked",
        "gui.howtos.make-a-game.step_GameAddScore": "Create Score Variable",
        "gui.howtos.make-a-game.step_GameChangeScore": "When Clicked Increase Score",
        "gui.howtos.make-a-game.step_Random": "Go to a random position",
        "gui.howtos.make-music.step_GameChangeColor": "Change Color",
        "gui.howtos.make-music.step_ResetScore": "Reset Score",
        "gui.howtos.make-a-chase-game.name": "Make a Chase Game",
        "gui.howtos.Chase-Game.step_BG": "Add a Backdrop",
        "gui.howtos.chase-game.step_AddOcto": "Add a Sprite",
        "gui.howtos.make-music.step_LeftRight": "Move Right & Left With Arrow Keys",
        "gui.howtos.Chase-Game.step_UpDown": "Move Up & Down With Arrow Keys",
        "gui.howtos.Chase-Game.step_AddStar": "Add Another Sprite",
        "gui.howtos.Chase-Game.step_MoveRandom": "Move Randomly",
        "gui.howtos.Chase-Game.step_WhenTouch": "In Octopus Sprite, When Touching Play Sound",
        "gui.howtos.Chase-Game.step_ScoreVariable": "Create Score Variable",
        "gui.howtos.Chase-Game.ScoreWhenTouch": "In Octopus Sprite, When Touching Add Score",
        "gui.howtos.code-cartoon": "Code a Cartoon",
        "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
        "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
        "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
        "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
        "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
        "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
        "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
        "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
        "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
        "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
        "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
        "gui.howtos.cartoon-network": "Animate an Adventure Game",
        "gui.howtos.cartoon-network.step_CNcharacter": "Choose a Character to Show",
        "gui.howtos.cartoon-network.step_CNsay": "Say Something",
        "gui.howtos.cartoon-network.step_CNglide": "Glide Around",
        "gui.howtos.cartoon-network.step_CNpicksprite": "Choose an Object to Chase",
        "gui.howtos.cartoon-network.step_CNcollect": "Collect Objects",
        "gui.howtos.cartoon-network.step_CNvariable": "Make a Score Variable",
        "gui.howtos.cartoon-network.step_CNscore": "Keep Score",
        "gui.howtos.cartoon-network.step_CNbackdrop": "Level Up: Change Backdrop",
        "gui.howtos.videosens.name": "Video Sensing",
        "gui.howtos.videosens.step_addextension": "Add Extension",
        "gui.howtos.videosens.step_pet": "Pet the Cat",
        "gui.howtos.videosens.step_animate": "Animate",
        "gui.howtos.videosens.step_pop": "Pop a Balloon",
        "gui.howtos.talking": "Talking Tales",
        "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
        "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
        "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
        "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
        "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
        "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
        "gui.howtos.talking.step_talesMoveAround": "Move Around",
        "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
        "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
        "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
        "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
        "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
        "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
        "gui.howtos.add-sprite.name": "Add a Sprite",
        "gui.howtos.add-sprite.step_addSprite": "Add a Sprite",
        "gui.howtos.add-a-backdrop.name": "Add a Backdrop",
        "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
        "gui.howtos.move-around-with-arrow-keys.name": "Use Arrow Keys",
        "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
        "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
        "gui.howtos.change-size.name": "Change Size",
        "gui.howtos.change-size.step_changeSize": "Change Size",
        "gui.howtos.glide-around.name": "Glide Around",
        "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
        "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
        "gui.howtos.spin-video.name": "Make It Spin",
        "gui.howtos.change-size.step_spinTurn": "Turn",
        "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
        "gui.howtos.record-a-sound.name": "Record a Sound",
        "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
        "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
        "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
        "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
        "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
        "gui.howtos.hide-and-show.name": "Hide and Show",
        "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
        "gui.howtos.switch-costume.name": "Animate a Sprite",
        "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
        "gui.extension.music.name": "Music",
        "gui.extension.music.description": "Play instruments and drums.",
        "gui.extension.pen.name": "Pen",
        "gui.extension.pen.description": "Draw with your sprites.",
        "gui.extension.videosensing.name": "Video Sensing",
        "gui.extension.videosensing.description": "Sense motion with the camera.",
        "gui.extension.text2speech.name": "Text to Speech",
        "gui.extension.text2speech.description": "Make your projects talk.",
        "gui.extension.translate.name": "Translate",
        "gui.extension.translate.description": "Translate text into many languages.",
        "gui.extension.makeymakey.description": "Make anything into a key.",
        "gui.extension.microbit.description": "Connect your projects with the world.",
        "gui.extension.microbit.connectingMessage": "Connecting",
        "gui.extension.ev3.description": "Build interactive robots and more.",
        "gui.extension.ev3.connectingMessage": "Connecting. Make sure the pin on your EV3 is set to 1234.",
        "gui.extension.boost.description": "Bring robotic creations to life.",
        "gui.extension.boost.connectingMessage": "Connecting",
        "gui.extension.wedo2.description": "Build with motors and sensors.",
        "gui.extension.wedo2.connectingMessage": "Connecting",
        "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
        "gui.extension.gdxfor.connectingMessage": "Connecting",
        "gui.libraryTags.all": "All",
        "gui.libraryTags.animals": "Animals",
        "gui.libraryTags.dance": "Dance",
        "gui.libraryTags.effects": "Effects",
        "gui.libraryTags.fantasy": "Fantasy",
        "gui.libraryTags.fashion": "Fashion",
        "gui.libraryTags.food": "Food",
        "gui.libraryTags.indoors": "Indoors",
        "gui.libraryTags.loops": "Loops",
        "gui.libraryTags.music": "Music",
        "gui.libraryTags.notes": "Notes",
        "gui.libraryTags.outdoors": "Outdoors",
        "gui.libraryTags.patterns": "Patterns",
        "gui.libraryTags.people": "People",
        "gui.libraryTags.percussion": "Percussion",
        "gui.libraryTags.space": "Space",
        "gui.libraryTags.sports": "Sports",
        "gui.libraryTags.underwater": "Underwater",
        "gui.libraryTags.voice": "Voice",
        "gui.libraryTags.wacky": "Wacky",
        "gui.libraryTags.animation": "Animation",
        "gui.libraryTags.art": "Art",
        "gui.libraryTags.games": "Games",
        "gui.libraryTags.stories": "Stories",
        "gui.libraryTags.letters": "Letters",
        "gui.opcodeLabels.direction": "direction",
        "gui.opcodeLabels.xposition": "x position",
        "gui.opcodeLabels.yposition": "y position",
        "gui.opcodeLabels.size": "size",
        "gui.opcodeLabels.costumename": "costume name",
        "gui.opcodeLabels.costumenumber": "costume number",
        "gui.opcodeLabels.backdropname": "backdrop name",
        "gui.opcodeLabels.backdropnumber": "backdrop number",
        "gui.opcodeLabels.volume": "volume",
        "gui.opcodeLabels.tempo": "tempo",
        "gui.opcodeLabels.answer": "answer",
        "gui.opcodeLabels.loudness": "loudness",
        "gui.opcodeLabels.username": "username",
        "gui.opcodeLabels.year": "year",
        "gui.opcodeLabels.month": "month",
        "gui.opcodeLabels.date": "date",
        "gui.opcodeLabels.dayofweek": "day of week",
        "gui.opcodeLabels.hour": "hour",
        "gui.opcodeLabels.minute": "minute",
        "gui.opcodeLabels.second": "second",
        "gui.opcodeLabels.timer": "timer",
        "gui.projectLoader.loadError": "The project file that was selected failed to load.",
        "gui.projectLoader.extremeProjectOnly": "This project is for the eXtreme module. Please switch to eXtreme from the module menu above and try loading it again.",
        "gui.projectLoader.xlineProjectOnly": "This project is for the X-LINE module. Please switch to X-LINE from the module menu above and try loading it again.",
        "gui.projectLoader.compatibilityModalTitle": "This file cannot be opened here.",
        "gui.projectLoader.compatibilityModalConfirm": "OK",
        "gui.sharedMessages.backdrop": "backdrop{index}",
        "gui.sharedMessages.costume": "costume{index}",
        "gui.sharedMessages.sprite": "Sprite{index}",
        "gui.sharedMessages.pop": "pop",
        "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
        "gui.sharedMessages.loadFromComputerTitle": "Load from your computer",
        "gui.theme.default": "Original",
        "gui.theme.dark": "Dark",
        "gui.theme.highContrast": "High Contrast",
        "gui.gui.defaultProjectTitle": "Scratch Project",
        "boost.color.any": "any color",
        "boost.color.black": "black",
        "boost.color.blue": "blue",
        "boost.color.green": "green",
        "boost.color.red": "red",
        "boost.color.white": "white",
        "boost.color.yellow": "yellow",
        "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
        "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
        "boost.motorDirection.backward": "that way",
        "boost.motorDirection.forward": "this way",
        "boost.motorDirection.reverse": "reverse",
        "boost.motorOff": "turn motor [MOTOR_ID] off",
        "boost.motorOn": "turn motor [MOTOR_ID] on",
        "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
        "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
        "boost.seeingColor": "seeing [COLOR] brick?",
        "boost.setLightHue": "set light color to [HUE]",
        "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
        "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
        "boost.tiltDirection.any": "any",
        "boost.tiltDirection.down": "down",
        "boost.tiltDirection.left": "left",
        "boost.tiltDirection.right": "right",
        "boost.tiltDirection.up": "up",
        "boost.whenColor": "when [COLOR] brick seen",
        "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
        "ev3.beepNote": "beep note [NOTE] for [TIME] secs",
        "ev3.buttonPressed": "button [PORT] pressed?",
        "ev3.getBrightness": "brightness",
        "ev3.getDistance": "distance",
        "ev3.getMotorPosition": "motor [PORT] position",
        "ev3.motorSetPower": "motor [PORT] set power [POWER] %",
        "ev3.motorTurnClockwise": "motor [PORT] turn this way for [TIME] seconds",
        "ev3.motorTurnCounterClockwise": "motor [PORT] turn that way for [TIME] seconds",
        "ev3.whenBrightnessLessThan": "when brightness < [DISTANCE]",
        "ev3.whenButtonPressed": "when button [PORT] pressed",
        "ev3.whenDistanceLessThan": "when distance < [DISTANCE]",
        "gdxfor.getAcceleration": "acceleration [DIRECTION]",
        "gdxfor.getForce": "force",
        "gdxfor.getSpin": "spin speed [DIRECTION]",
        "gdxfor.getTilt": "tilt angle [TILT]",
        "gdxfor.isFreeFalling": "falling?",
        "gdxfor.isTilted": "tilted [TILT]?",
        "gdxfor.pulled": "pulled",
        "gdxfor.pushed": "pushed",
        "gdxfor.shaken": "shaken",
        "gdxfor.startedFalling": "started falling",
        "gdxfor.tiltDirectionMenu.any": "any",
        "gdxfor.tiltDirectionMenu.back": "back",
        "gdxfor.tiltDirectionMenu.front": "front",
        "gdxfor.tiltDirectionMenu.left": "left",
        "gdxfor.tiltDirectionMenu.right": "right",
        "gdxfor.turnedFaceDown": "turned face down",
        "gdxfor.turnedFaceUp": "turned face up",
        "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
        "gdxfor.whenGesture": "when [GESTURE]",
        "gdxfor.whenTilted": "when tilted [TILT]",
        "makeymakey.downArrow": "down arrow",
        "makeymakey.downArrowShort": "down",
        "makeymakey.leftArrow": "left arrow",
        "makeymakey.leftArrowShort": "left",
        "makeymakey.rightArrow": "right arrow",
        "makeymakey.rightArrowShort": "right",
        "makeymakey.spaceKey": "space",
        "makeymakey.upArrow": "up arrow",
        "makeymakey.upArrowShort": "up",
        "makeymakey.whenKeyPressed": "when [KEY] key pressed",
        "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
        "microbit.buttonsMenu.any": "any",
        "microbit.clearDisplay": "clear display",
        "microbit.defaultTextToDisplay": "Hello!",
        "microbit.displaySymbol": "display [MATRIX]",
        "microbit.displayText": "display text [TEXT]",
        "microbit.gesturesMenu.jumped": "jumped",
        "microbit.gesturesMenu.moved": "moved",
        "microbit.gesturesMenu.shaken": "shaken",
        "microbit.isButtonPressed": "[BTN] button pressed?",
        "microbit.isTilted": "tilted [DIRECTION]?",
        "microbit.pinStateMenu.off": "off",
        "microbit.pinStateMenu.on": "on",
        "microbit.tiltAngle": "tilt angle [DIRECTION]",
        "microbit.tiltDirectionMenu.any": "any",
        "microbit.tiltDirectionMenu.back": "back",
        "microbit.tiltDirectionMenu.front": "front",
        "microbit.tiltDirectionMenu.left": "left",
        "microbit.tiltDirectionMenu.right": "right",
        "microbit.whenButtonPressed": "when [BTN] button pressed",
        "microbit.whenGesture": "when [GESTURE]",
        "microbit.whenPinConnected": "when pin [PIN] connected",
        "microbit.whenTilted": "when tilted [DIRECTION]",
        "music.categoryName": "Music",
        "music.changeTempo": "change tempo by [TEMPO]",
        "music.drumBass": "(2) Bass Drum",
        "music.drumBongo": "(13) Bongo",
        "music.drumCabasa": "(15) Cabasa",
        "music.drumClaves": "(9) Claves",
        "music.drumClosedHiHat": "(6) Closed Hi-Hat",
        "music.drumConga": "(14) Conga",
        "music.drumCowbell": "(11) Cowbell",
        "music.drumCrashCymbal": "(4) Crash Cymbal",
        "music.drumCuica": "(18) Cuica",
        "music.drumGuiro": "(16) Guiro",
        "music.drumHandClap": "(8) Hand Clap",
        "music.drumOpenHiHat": "(5) Open Hi-Hat",
        "music.drumSideStick": "(3) Side Stick",
        "music.drumSnare": "(1) Snare Drum",
        "music.drumTambourine": "(7) Tambourine",
        "music.drumTriangle": "(12) Triangle",
        "music.drumVibraslap": "(17) Vibraslap",
        "music.drumWoodBlock": "(10) Wood Block",
        "music.getTempo": "tempo",
        "music.instrumentBass": "(6) Bass",
        "music.instrumentBassoon": "(14) Bassoon",
        "music.instrumentCello": "(8) Cello",
        "music.instrumentChoir": "(15) Choir",
        "music.instrumentClarinet": "(10) Clarinet",
        "music.instrumentElectricGuitar": "(5) Electric Guitar",
        "music.instrumentElectricPiano": "(2) Electric Piano",
        "music.instrumentFlute": "(12) Flute",
        "music.instrumentGuitar": "(4) Guitar",
        "music.instrumentMarimba": "(19) Marimba",
        "music.instrumentMusicBox": "(17) Music Box",
        "music.instrumentOrgan": "(3) Organ",
        "music.instrumentPiano": "(1) Piano",
        "music.instrumentPizzicato": "(7) Pizzicato",
        "music.instrumentSaxophone": "(11) Saxophone",
        "music.instrumentSteelDrum": "(18) Steel Drum",
        "music.instrumentSynthLead": "(20) Synth Lead",
        "music.instrumentSynthPad": "(21) Synth Pad",
        "music.instrumentTrombone": "(9) Trombone",
        "music.instrumentVibraphone": "(16) Vibraphone",
        "music.instrumentWoodenFlute": "(13) Wooden Flute",
        "music.midiPlayDrumForBeats": "play drum [DRUM] for [BEATS] beats",
        "music.midiSetInstrument": "set instrument to [INSTRUMENT]",
        "music.playDrumForBeats": "play drum [DRUM] for [BEATS] beats",
        "music.playNoteForBeats": "play note [NOTE] for [BEATS] beats",
        "music.restForBeats": "rest for [BEATS] beats",
        "music.setInstrument": "set instrument to [INSTRUMENT]",
        "music.setTempo": "set tempo to [TEMPO]",
        "pen.categoryName": "Pen",
        "pen.changeColorParam": "change pen [COLOR_PARAM] by [VALUE]",
        "pen.changeHue": "change pen color by [HUE]",
        "pen.changeShade": "change pen shade by [SHADE]",
        "pen.changeSize": "change pen size by [SIZE]",
        "pen.clear": "erase all",
        "pen.colorMenu.brightness": "brightness",
        "pen.colorMenu.color": "color",
        "pen.colorMenu.saturation": "saturation",
        "pen.colorMenu.transparency": "transparency",
        "pen.penDown": "pen down",
        "pen.penUp": "pen up",
        "pen.setColor": "set pen color to [COLOR]",
        "pen.setColorParam": "set pen [COLOR_PARAM] to [VALUE]",
        "pen.setHue": "set pen color to [HUE]",
        "pen.setShade": "set pen shade to [SHADE]",
        "pen.setSize": "set pen size to [SIZE]",
        "pen.stamp": "stamp",
        "speech.defaultWhenIHearValue": "let''s go",
        "speech.extensionName": "Speech to Text",
        "speech.listenAndWait": "listen and wait",
        "speech.speechReporter": "speech",
        "speech.whenIHear": "when I hear [PHRASE]",
        "text2speech.alto": "alto",
        "text2speech.categoryName": "Text to Speech",
        "text2speech.defaultTextToSpeak": "hello",
        "text2speech.giant": "giant",
        "text2speech.kitten": "kitten",
        "text2speech.setLanguageBlock": "set language to [LANGUAGE]",
        "text2speech.setVoiceBlock": "set voice to [VOICE]",
        "text2speech.speakAndWaitBlock": "speak [WORDS]",
        "text2speech.squeak": "squeak",
        "text2speech.tenor": "tenor",
        "translate.categoryName": "Translate",
        "translate.defaultTextToTranslate": "hello",
        "translate.translateBlock": "translate [WORDS] to [LANGUAGE]",
        "translate.viewerLanguage": "language",
        "videoSensing.categoryName": "Video Sensing",
        "videoSensing.direction": "direction",
        "videoSensing.motion": "motion",
        "videoSensing.off": "off",
        "videoSensing.on": "on",
        "videoSensing.onFlipped": "on flipped",
        "videoSensing.setVideoTransparency": "set video transparency to [TRANSPARENCY]",
        "videoSensing.sprite": "sprite",
        "videoSensing.stage": "stage",
        "videoSensing.videoOn": "video [ATTRIBUTE] on [SUBJECT]",
        "videoSensing.videoToggle": "turn video [VIDEO_STATE]",
        "videoSensing.whenMotionGreaterThan": "when video motion > [REFERENCE]",
        "wedo2.getDistance": "distance",
        "wedo2.getTiltAngle": "tilt angle [TILT_DIRECTION]",
        "wedo2.isTilted": "tilted [TILT_DIRECTION_ANY]?",
        "wedo2.motorDirection.backward": "that way",
        "wedo2.motorDirection.forward": "this way",
        "wedo2.motorDirection.reverse": "reverse",
        "wedo2.motorId.a": "motor A",
        "wedo2.motorId.all": "all motors",
        "wedo2.motorId.b": "motor B",
        "wedo2.motorId.default": "motor",
        "wedo2.motorOff": "turn [MOTOR_ID] off",
        "wedo2.motorOn": "turn [MOTOR_ID] on",
        "wedo2.motorOnFor": "turn [MOTOR_ID] on for [DURATION] seconds",
        "wedo2.playNoteFor": "play note [NOTE] for [DURATION] seconds",
        "wedo2.setLightHue": "set light color to [HUE]",
        "wedo2.setMotorDirection": "set [MOTOR_ID] direction to [MOTOR_DIRECTION]",
        "wedo2.startMotorPower": "set [MOTOR_ID] power to [POWER]",
        "wedo2.tiltDirection.any": "any",
        "wedo2.tiltDirection.down": "down",
        "wedo2.tiltDirection.left": "left",
        "wedo2.tiltDirection.right": "right",
        "wedo2.tiltDirection.up": "up",
        "wedo2.whenDistance": "when distance [OP] [REFERENCE]",
        "wedo2.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
        "paint.paintEditor.hue": "Color",
        "paint.paintEditor.saturation": "Saturation",
        "paint.paintEditor.brightness": "Brightness",
        "paint.paintEditor.costume": "Costume",
        "paint.paintEditor.group": "Group",
        "paint.paintEditor.ungroup": "Ungroup",
        "paint.paintEditor.undo": "Undo",
        "paint.paintEditor.redo": "Redo",
        "paint.paintEditor.forward": "Forward",
        "paint.paintEditor.backward": "Backward",
        "paint.paintEditor.front": "Front",
        "paint.paintEditor.back": "Back",
        "paint.paintEditor.more": "More",
        "paint.modeTools.brushSize": "Size",
        "paint.modeTools.eraserSize": "Eraser size",
        "paint.modeTools.copy": "Copy",
        "paint.modeTools.paste": "Paste",
        "paint.modeTools.delete": "Delete",
        "paint.modeTools.curved": "Curved",
        "paint.modeTools.pointed": "Pointed",
        "paint.modeTools.thickness": "Thickness",
        "paint.modeTools.flipHorizontal": "Flip Horizontal",
        "paint.modeTools.flipVertical": "Flip Vertical",
        "paint.modeTools.filled": "Filled",
        "paint.modeTools.outlined": "Outlined",
        "paint.paintEditor.bitmap": "Convert to Bitmap",
        "paint.paintEditor.vector": "Convert to Vector",
        "paint.paintEditor.fill": "Fill",
        "paint.paintEditor.stroke": "Outline",
        "paint.brushMode.brush": "Brush",
        "paint.eraserMode.eraser": "Eraser",
        "paint.fillMode.fill": "Fill",
        "paint.lineMode.line": "Line",
        "paint.ovalMode.oval": "Circle",
        "paint.rectMode.rect": "Rectangle",
        "paint.reshapeMode.reshape": "Reshape",
        "paint.roundedRectMode.roundedRect": "Rounded Rectangle",
        "paint.selectMode.select": "Select",
        "paint.textMode.text": "Text",
        "paint.colorPicker.swap": "Swap"
    },
    "ko": {
        "gui.alerts.lostPeripheralConnection": "스크래치와 {extensionName} 사이의 연결이 끊어졌습니다.",
        "gui.alerts.tryAgain": "다시 시도",
        "gui.alerts.download": "다운로드",
        "gui.connection.reconnect": "다시 연결",
        "gui.backpack.costumeLabel": "costume",
        "gui.backpack.soundLabel": "sound",
        "gui.backpack.scriptLabel": "script",
        "gui.backpack.spriteLabel": "sprite",
        "gui.backpack.header": "개인 저장소",
        "gui.backpack.errorBackpack": "개인 저장소를 불러오는 중 오류 ",
        "gui.backpack.loadingBackpack": "로딩중...",
        "gui.backpack.more": "더 보기",
        "gui.backpack.emptyBackpack": "개인 저장소가 비었습니다",
        "gui.unsupportedBrowser.label": "브라우저가 지원되지 않습니다.",
        "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
        "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
        "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
        "gui.unsupportedBrowser.back": "뒤로",
        "gui.unsupportedBrowser.previewfaq": "더 알아보려면, {previewFaqLink}로 이동하세요.",
        "gui.unsupportedBrowser.previewfaqlinktext": "자주 묻는 질문(FAQ)",
        "gui.cards.all-tutorials": "튜토리얼",
        "gui.cards.shrink": "Shrink",
        "gui.cards.expand": "Expand",
        "gui.cards.close": "닫기",
        "gui.cards.more-things-to-try": "해 볼 만한 다른 것들!",
        "gui.cards.see-more": "더 보기",
        "gui.comingSoon.message1": "걱정 마세요, 작업 중입니다 {emoji}",
        "gui.comingSoon.message2": "곧 이용 가능합니다...",
        "gui.comingSoon.message3": "작업 중입니다 {emoji}",
        "gui.connection.auto-scanning.noPeripheralsFound": "발견된 기기가 없습니다",
        "gui.connection.auto-scanning.prescan": "주변에 기기가 있는 지 확인 후 검색을 시작하세요. ",
        "gui.connection.auto-scanning.pressbutton": "기기의 버튼을 누르세요",
        "gui.connection.auto-scanning.start-search": "검색 시작",
        "gui.connection.connecting-searchbutton": "검색 중...",
        "gui.connection.auto-scanning.try-again": "다시 시도",
        "gui.connection.auto-scanning.updatePeripheralButton": "Update my Device",
        "gui.connection.connected": "연결됨 ",
        "gui.connection.disconnect": "연결 끊기 ",
        "gui.connection.go-to-editor": "편집기로 가기 ",
        "gui.connection.connecting-cancelbutton": "연결 중...",
        "gui.connection.error.errorMessage": "이런, 뭔가 잘못된 것 같네요. ",
        "gui.connection.error.tryagainbutton": "다시 시도",
        "gui.connection.error.helpbutton": "도움말",
        "gui.connection.peripheral-name-label": "기기 이름",
        "gui.connection.connect": "연결하기",
        "gui.connection.scanning.lookingforperipherals": "기기를 찾는 중",
        "gui.connection.scanning.noPeripheralsFound": "발견된 기기가 없습니다",
        "gui.connection.scanning.instructions": "위의 목록에서 사용자의 기기를 선택하세요.",
        "gui.connection.search": "새로 고침",
        "gui.connection.scanning.updatePeripheralButton": "Update my Device",
        "gui.connection.unavailable.installscratchlink": "Scratch Link가 설치되었고 실행되는지 확인하세요",
        "gui.connection.unavailable.enablebluetooth": "블루투스가 사용 가능한지 확인하세요",
        "gui.connection.unavailable.tryagainbutton": "다시 시도",
        "gui.connection.unavailable.helpbutton": "도움말",
        "gui.connection.updatePeripheral.microBitConnect": "Connect your {extensionName} to this device using a USB cable.",
        "gui.connection.updatePeripheral.pressUpdate": "Press \"Do Update\" and allow the update to complete.",
        "gui.connection.updatePeripheral.progress": "Updating {progressPercentage}%",
        "gui.connection.updatePeripheral.updateSuccessful": "Update successful!",
        "gui.connection.updatePeripheral.updateFailed": "Update failed.",
        "gui.connection.updatePeripheral.goBackButton": "Go Back",
        "gui.connection.updatePeripheral.updateNowButton": "Do Update",
        "gui.connection.updatePeripheral.updateAgainButton": "Try Again",
        "gui.controls.go": "시작하기",
        "gui.controls.stop": "멈추기",
        "gui.crashMessage.label": "이런! 무언가가 잘못되었습니다.",
        "gui.crashMessage.description": "정말로 죄송하지만, 스크래치에 문제가 생긴 것으로 보입니다. 이 오류는 자동으로 스크래치 팀에게 접수되었습니다. 다시 시도하려면 페이지를 새로고침하세요.",
        "gui.crashMessage.errorNumber": "Your error was logged with id {errorId}",
        "gui.crashMessage.reload": "새로 고침",
        "gui.customProcedures.myblockModalTitle": "블록 만들기",
        "gui.customProcedures.addAnInputNumberText": "입력값 추가하기",
        "gui.customProcedures.numberTextType": "숫자 또는 문자열",
        "gui.customProcedures.addAnInputBoolean": "입력값 추가하기",
        "gui.customProcedures.booleanType": "논리값",
        "gui.customProcedures.addALabel": "라벨 넣기",
        "gui.customProcedures.runWithoutScreenRefresh": "화면 새로고침 없이 실행하기",
        "gui.customProcedures.cancel": "취소",
        "gui.customProcedures.ok": "확인",
        "gui.gui.shouldDeleteSprite": "Are you sure you want to delete this sprite?",
        "gui.gui.shouldDeleteCostume": "Are you sure you want to delete this costume?",
        "gui.gui.shouldDeleteSound": "Are you sure you want to delete this sound?",
        "gui.gui.confirm": "yes",
        "gui.gui.cancel": "no",
        "gui.gui.deleteAssetHeading": "Confirm Asset Deletion",
        "gui.SpriteInfo.direction": "방향",
        "gui.directionPicker.rotationStyles.allAround": "회전하기",
        "gui.directionPicker.rotationStyles.leftRight": "왼쪽/오른쪽",
        "gui.directionPicker.rotationStyles.dontRotate": "회전하지 않기",
        "gui.gui.addExtension": "확장 기능 추가하기",
        "gui.gui.codeTab": "코드",
        "gui.gui.backdropsTab": "배경",
        "gui.gui.costumesTab": "모양",
        "gui.gui.soundsTab": "소리",
        "gui.extensionLibrary.comingSoon": "곧 이용 가능",
        "gui.extensionLibrary.requires": "요구사항",
        "gui.extensionLibrary.collaboration": "협력사",
        "gui.library.filterPlaceholder": "검색",
        "gui.library.allTag": "모두",
        "gui.library.gettingStarted": "Getting Started",
        "gui.library.basics": "Basics",
        "gui.library.intermediate": "Intermediate",
        "gui.library.prompts": "Prompts",
        "gui.loader.message1": "블록을 생성하는 중...",
        "gui.loader.message2": "스프라이트를 불러오는 중...",
        "gui.loader.message3": "소리를 불러오는 중...",
        "gui.loader.message4": "확장 기능을 불러오는 중...",
        "gui.loader.message5": "고양이를 몰고 가는 중...",
        "gui.loader.message6": "나노를 전송하는 중...",
        "gui.loader.message7": "고보를 팽창시키는 중...",
        "gui.loader.message8": "이모티콘을 준비하는 중...",
        "gui.loader.headline": "프로젝트를 불러오는 중",
        "gui.loader.creating": "생성된 프로젝트",
        "gui.accountMenu.profile": "내 정보",
        "gui.accountMenu.myStuff": "내 작업실",
        "gui.accountMenu.myClasses": "내 학급",
        "gui.accountMenu.myClass": "내 학급",
        "gui.accountMenu.accountSettings": "계정 설정",
        "gui.accountMenu.signOut": "로그아웃",
        "gui.authorInfo.byUser": "제작자: {username}",
        "gui.menuBar.seeProjectPage": "프로젝트 페이지 보기",
        "gui.menuBar.language": "언어",
        "general.username": "사용자 이름",
        "general.password": "비밀번호",
        "general.signIn": "로그인",
        "login.needHelp": "도움이 필요한가요?",
        "form.validationRequired": "필수 항목입니다",
        "gui.menuBar.tutorialsLibrary": "튜토리얼",
        "gui.menuBar.restoreSprite": "스프라이트 되돌리기",
        "gui.menuBar.restoreSound": "소리 되돌리기",
        "gui.menuBar.restoreCostume": "모양 되돌리기",
        "gui.menuBar.restore": "되돌리기",
        "gui.menuBar.saveNow": "저장하기",
        "gui.menuBar.saveAsCopy": "복사본 저장하기",
        "gui.menuBar.remix": "리믹스",
        "gui.menuBar.new": "새로 만들기",
        "gui.menuBar.file": "파일",
        "gui.menuBar.downloadToComputer": "컴퓨터에 저장하기 ",
        "gui.menuBar.edit": "편집",
        "gui.menuBar.turboModeOff": "터보 모드 끄기",
        "gui.menuBar.turboModeOn": "터보 모드 켜기",
        "gui.menuBar.modeMenu": "모드",
        "gui.menuBar.normalMode": "그냥 스크래치 모드",
        "gui.menuBar.caturdayMode": "냥토 모드",
        "gui.menuBar.joinScratch": "스크래치 가입",
        "gui.menuBar.signIn": "로그인",
        "gui.gui.projectTitlePlaceholder": "프로젝트 제목을 입력하세요",
        "gui.menuBar.saveNowLink": "바로 저장하기",
        "gui.menuBar.settings": "설정",
        "gui.menuBar.isShared": "공유됨",
        "gui.menuBar.share": "공유",
        "gui.menuBar.colorMode": "색상 모드",
        "gui.modal.help": "도움말",
        "gui.modal.back": "뒤로",
        "gui.monitor.listMonitor.empty": "(비어 있음)",
        "gui.monitor.listMonitor.listLength": "길이 {length}",
        "gui.monitor.contextMenu.default": "변수이름-변수값 보기",
        "gui.monitor.contextMenu.large": "변수값 크게 보기",
        "gui.monitor.contextMenu.slider": "슬라이더 사용하기",
        "gui.monitor.contextMenu.sliderRange": "change slider range",
        "gui.monitor.contextMenu.import": "가져오기",
        "gui.monitor.contextMenu.export": "내보내기",
        "gui.monitor.contextMenu.hide": "hide",
        "gui.playButton.play": "Play",
        "gui.playButton.stop": "Stop",
        "gui.gui.variableScopeOptionAllSprites": "모든 스프라이트에서 사용",
        "gui.gui.variableScopeOptionSpriteOnly": "이 스프라이트에서만 사용",
        "gui.gui.cloudVariableOption": "클라우드 변수 (서버에 저장됨)",
        "gui.gui.variablePromptAllSpritesMessage": "이 변수는 모든 스프라이트에서 사용할 수 있습니다.",
        "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
        "gui.prompt.cancel": "취소",
        "gui.prompt.ok": "확인",
        "gui.playbackStep.stopMsg": "멈추기",
        "gui.playbackStep.playMsg": "재생",
        "gui.playbackStep.loadingMsg": "로딩 중...",
        "gui.playbackStep.saveMsg": "저장",
        "gui.playbackStep.reRecordMsg": "다시 녹음하기",
        "gui.recordModal.title": "소리 녹음하기",
        "gui.recordingStep.beginRecord": "아래에 있는 버튼을 눌러서 녹음을 시작하세요",
        "gui.recordingStep.permission": "{arrow}마이크를 사용하려면 사용자의 허락이 필요합니다",
        "gui.recordingStep.stop": "녹음 멈추기",
        "gui.recordingStep.record": "녹음하기",
        "gui.sliderModal.min": "Minimum value",
        "gui.sliderModal.max": "Maximum value",
        "gui.sliderModal.title": "Change slider range",
        "gui.sliderPrompt.cancel": "Cancel",
        "gui.sliderPrompt.ok": "OK",
        "gui.soundEditor.sound": "소리",
        "gui.soundEditor.play": "재생",
        "gui.soundEditor.stop": "멈추기",
        "gui.soundEditor.copy": "복사",
        "gui.soundEditor.paste": "Paste",
        "gui.soundEditor.copyToNew": "새로운 소리로 복사",
        "gui.soundEditor.delete": "삭제",
        "gui.soundEditor.save": "저장",
        "gui.soundEditor.undo": "되돌리기",
        "gui.soundEditor.redo": "재시도",
        "gui.soundEditor.faster": "빠르게",
        "gui.soundEditor.slower": "느리게",
        "gui.soundEditor.echo": "메아리",
        "gui.soundEditor.robot": "로봇",
        "gui.soundEditor.louder": "크게",
        "gui.soundEditor.softer": "작게",
        "gui.soundEditor.reverse": "뒤집기",
        "gui.soundEditor.fadeOut": "점점 작게",
        "gui.soundEditor.fadeIn": "점점 크게",
        "gui.soundEditor.mute": "음소거",
        "gui.SpriteInfo.spritePlaceholder": "이름",
        "gui.SpriteInfo.showSpriteAction": "Show sprite",
        "gui.SpriteInfo.hideSpriteAction": "Hide sprite",
        "gui.SpriteInfo.sprite": "스프라이트",
        "gui.SpriteInfo.show": "보이기",
        "gui.SpriteInfo.size": "크기",
        "gui.spriteSelectorItem.contextMenuDuplicate": "복사",
        "gui.spriteSelectorItem.contextMenuExport": "내보내기",
        "gui.spriteSelectorItem.contextMenuDelete": "삭제",
        "gui.spriteSelector.addSpriteFromLibrary": "스프라이트 고르기",
        "gui.spriteSelector.addSpriteFromPaint": "그리기",
        "gui.spriteSelector.addSpriteFromSurprise": "서프라이즈",
        "gui.spriteSelector.addSpriteFromFile": "스프라이트 업로드하기",
        "gui.stageHeader.stageSizeLarge": "큰 무대로 전환하기",
        "gui.stageHeader.stageSizeSmall": "작은 무대로 전환하기 ",
        "gui.stageHeader.stageSizeFull": "전체 화면 모드로 전환하기 ",
        "gui.stageHeader.stageSizeUnFull": "전체 화면 모드 종료하기",
        "gui.stageHeader.fullscreenControl": "전체 화면",
        "gui.spriteSelector.addBackdropFromLibrary": "배경 고르기",
        "gui.stageSelector.addBackdropFromPaint": "그리기",
        "gui.stageSelector.addBackdropFromSurprise": "서프라이즈 ",
        "gui.stageSelector.addBackdropFromFile": "배경 업로드하기",
        "gui.stageSelector.stage": "무대",
        "gui.stageSelector.backdrops": "배경",
        "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
        "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
        "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
        "gui.telemetryOptIn.privacyPolicyLink": "개인정보보호 정책",
        "gui.telemetryOptIn.optInText": "Share my usage data with the Scratch Team",
        "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
        "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Scratch Team",
        "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
        "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
        "gui.telemetryOptIn.buttonClose": "Close",
        "gui.turboMode.active": "터보 모드",
        "gui.webglModal.label": "브라우저가 WebGL을 지원하지 않습니다",
        "gui.webglModal.description": "아쉽지만 브라우저 또는 컴퓨터가 {webGlLink}로 보입니다. 스크래치 3.0을 실행하려면 이 장치가 필요합니다.",
        "gui.webglModal.webgllink": "WebGL을 지원하지 않는 상태",
        "gui.webglModal.back": "뒤로",
        "gui.webglModal.previewfaq": "더 알아보려면, {previewFaqLink}로 이동하세요.",
        "gui.webglModal.previewfaqlinktext": "자주 묻는 질문(FAQ)",
        "gui.costumeLibrary.chooseABackdrop": "배경 고르기",
        "gui.costumeLibrary.chooseACostume": "모양 고르기",
        "gui.costumeTab.addBackdropFromLibrary": "배경 고르기",
        "gui.costumeTab.addCostumeFromLibrary": "모양 고르기",
        "gui.costumeTab.addBlankCostume": "그리기",
        "gui.costumeTab.addSurpriseCostume": "서프라이즈 ",
        "gui.costumeTab.addFileBackdrop": "배경 업로드하기",
        "gui.costumeTab.addFileCostume": "모양 업로드하기",
        "gui.extensionLibrary.chooseAnExtension": "확장 기능 고르기",
        "gui.extensionLibrary.extensionUrl": "Enter the URL of the extension",
        "gui.monitors.importListColumnPrompt": "Which column should be used (1-{numberOfColumns})?",
        "gui.recordingStep.alertMsg": "녹음을 시작할 수 없음",
        "gui.soundLibrary.chooseASound": "소리 고르기",
        "gui.soundTab.fileUploadSound": "소리 업로드하기",
        "gui.soundTab.surpriseSound": "서프라이즈 ",
        "gui.soundTab.recordSound": "녹음하기",
        "gui.soundTab.addSoundFromLibrary": "소리 고르기",
        "gui.spriteLibrary.chooseASprite": "스프라이트 고르기",
        "gui.tipsLibrary.tutorials": "튜토리얼 고르기",
        "gui.alerts.createsuccess": "새 프로젝트가 생성되었습니다.",
        "gui.alerts.createcopysuccess": "복사본으로 프로젝트가 저장되었습니다.",
        "gui.alerts.createremixsuccess": "리믹스로 프로젝트가 저장되었습니다.",
        "gui.alerts.creating": "새로 만드는 중...",
        "gui.alerts.creatingCopy": "프로젝트 복사중...",
        "gui.alerts.creatingRemix": "프로젝트 리믹스 중...",
        "gui.alerts.creatingError": "프로젝트를 생성하지 못했습니다. 다시 시도해 주세요!",
        "gui.alerts.savingError": "프로젝트를 저장하지 못했습니다.",
        "gui.alerts.savesuccess": "프로젝트가 저장되었습니다.",
        "gui.alerts.saving": "프로젝트 저장 중...",
        "gui.alerts.cloudInfo": "클라우드 변수는 숫자만 지원하며 문자나 특수기호는 지원하지 않습니다. {learnMoreLink}",
        "gui.alerts.cloudInfoLearnMore": "더 알아보기",
        "gui.alerts.importing": "Importing…",
        "gui.defaultProject.meow": "야옹",
        "gui.defaultProject.variable": "나의 변수",
        "gui.howtos.intro-move-sayhello-hat.name": "시작하기",
        "gui.howtos.intro-move.step_stepMove": "이동 블록 추가하기 ",
        "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
        "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
        "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
        "gui.howtos.animate-a-name.name": "이름으로 애니메이션 만들기",
        "gui.howtos.animate-a-name.step_AnimatePickLetter": "글자 스프라이트 선택하기 ",
        "gui.howtos.animate-a-name.step_AnimatePlaySound": "클릭할 때 소리 재생하기",
        "gui.howtos.animate-a-name.step_AnimatePickLetter2": "다른 글자 스프라이트 선택하기 ",
        "gui.howtos.animate-a-name.step_AnimateChangeColor": "색 바꾸기",
        "gui.howtos.animate-a-name.step_AnimateSpin": "Pick Another Letter Sprite & Make It Spin",
        "gui.howtos.animate-a-name.step_AnimateGrow": "다른 글자 스프라이트를 선택하고 크기 늘리기",
        "gui.howtos.animate-char.name": "캐릭터를 애니메이션으로 만들기",
        "gui.howtos.animate-char.step_addbg": "배경 추가하기",
        "gui.howtos.animate-char.step_addsprite": "스프라이트 추가하기",
        "gui.howtos.animate-char.step_saysomething": "무엇이든지 말하기",
        "gui.howtos.animate-char.step_addsound": "소리 추가하기",
        "gui.howtos.animate-char.step_animatetalking": "대화를 애니메이션으로 만들기",
        "gui.howtos.animate-char.step_arrowkeys": "방향키로 움직이기",
        "gui.howtos.animate-char.step_jump": "점프하기",
        "gui.howtos.animate-char.step_changecolor": "색 바꾸기",
        "gui.howtos.story.name": "이야기 만들기",
        "gui.howtos.story.step_addbg": "배경 추가하기",
        "gui.howtos.story.step_addsprite": "캐릭터 추가하기",
        "gui.howtos.story.step_saysomething": "무엇이든지 말하기",
        "gui.howtos.story.step_addanothersprite": "다른 캐릭터 추가하기",
        "gui.howtos.story.step_flip": "방향 바꾸기",
        "gui.howtos.story.step_conversation": "대화하기",
        "gui.howtos.story.addanotherbg": "다른 배경 추가하기",
        "gui.howtos.story.step_swithbg": "배경 바꾸기",
        "gui.howtos.story.step_hidewizard": "캐릭터 숨기기",
        "gui.howtos.story.step_showwizard": "캐릭터 보이기",
        "gui.howtos.say-it-out-loud": "대화하는 애니메이션 만들기",
        "gui.howtos.say-it-out-loud.step_AddTXTextension": "텍스트 음성 변환 블록 추가하기",
        "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
        "gui.howtos.say-it-out-loud_TXTSetVoice": "목소리 정하기",
        "gui.howtos.say-it-out-loud.step_TXTMove": "돌아다니기",
        "gui.howtos.say-it-out-loud.step_TXTBackdrop": "배경 추가하기",
        "gui.howtos.say-it-out-loud.step_TXTAddSprite": "다른 캐릭터 추가하기",
        "gui.howtos.say-it-out-loud.step_TXTSong": "노래 자랑하기",
        "gui.howtos.say-it-out-loud.step_TXTColor": "색 바꾸기",
        "gui.howtos.say-it-out-loud.step_TXTSpin": "빙글빙글 돌기",
        "gui.howtos.say-it-out-loud.step_TXTGrow": "커지고 작아지기",
        "gui.howtos.imagine": "Imagine a World",
        "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
        "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
        "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
        "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
        "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
        "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
        "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
        "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
        "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
        "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
        "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
        "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
        "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
        "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
        "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
        "gui.howtos.add-effects.name": "효과 넣기",
        "gui.howtos.videosens.step_addEffects": "Add Effects",
        "gui.howtos.make-it-fly.name": "Make it Fly",
        "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
        "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
        "gui.howtos.fly.step_stepflySaySomething": "Say Something",
        "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
        "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
        "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
        "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
        "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
        "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
        "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
        "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
        "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
        "gui.howtos.make-music.name": "음악 만들기",
        "gui.howtos.Make-Music.step_PickInstrument": "악기 스프라이트 선택하기 ",
        "gui.howtos.Make-Music.step_PlaySoundClick": "클릭할 때 소리 재생",
        "gui.howtos.Make-Music.step_MakeSong": "노래 만들기",
        "gui.howtos.make-music.step_MakeBeat": "타악기 고르기 & 리듬 만들기",
        "gui.howtos.make-music.step_MakeBeatBox": "마이크 스프라이트 및 서프라이즈 비트박스 선택하기",
        "gui.howtos.pong": "Pong Game",
        "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
        "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
        "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
        "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
        "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
        "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
        "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
        "gui.howtos.pong.step_pongAddAScore": "Add a Score",
        "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
        "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
        "gui.howtos.pong.step_pongResetScore": "Reset Score",
        "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
        "gui.howtos.pong.step_pongGameOver": "Game Over",
        "gui.howtos.make-a-game.name": "클릭하는 게임 만들기",
        "gui.howtos.Make-A-Game.step_GamePickSprite": "스프라이트 고르기",
        "gui.howtos.make-a-game.step_GamePlaySound": "클릭할 때 소리 재생하기",
        "gui.howtos.make-a-game.step_GameAddScore": "점수 변수 만들기 ",
        "gui.howtos.make-a-game.step_GameChangeScore": "클릭할 때 점수 올리기",
        "gui.howtos.make-a-game.step_Random": "아무 데나 이동하기",
        "gui.howtos.make-music.step_GameChangeColor": "색 바꾸기",
        "gui.howtos.make-music.step_ResetScore": "점수 초기화하기",
        "gui.howtos.make-a-chase-game.name": "잡기 게임 만들기",
        "gui.howtos.Chase-Game.step_BG": "배경 추가하기",
        "gui.howtos.chase-game.step_AddOcto": "스프라이트 추가하기",
        "gui.howtos.make-music.step_LeftRight": "방향키를 눌러서 왼쪽 & 오른쪽으로 움직이기",
        "gui.howtos.Chase-Game.step_UpDown": "방향키를 눌러서 위쪽 & 아래쪽으로 움직이기",
        "gui.howtos.Chase-Game.step_AddStar": "다른 스프라이트 추가하기",
        "gui.howtos.Chase-Game.step_MoveRandom": "무작위로 움직이기",
        "gui.howtos.Chase-Game.step_WhenTouch": "문어 스프라이트가 닿을 때 소리 재생하기",
        "gui.howtos.Chase-Game.step_ScoreVariable": "점수 변수 만들기 ",
        "gui.howtos.Chase-Game.ScoreWhenTouch": "문어 스프라이트가 닿을 때 점수 올리기",
        "gui.howtos.code-cartoon": "Code a Cartoon",
        "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
        "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
        "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
        "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
        "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
        "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
        "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
        "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
        "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
        "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
        "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
        "gui.howtos.cartoon-network": "어드벤처 게임을 움직이게 만들기",
        "gui.howtos.cartoon-network.step_CNcharacter": "보여줄 캐릭터 고르기",
        "gui.howtos.cartoon-network.step_CNsay": "무엇이든지 말하기",
        "gui.howtos.cartoon-network.step_CNglide": "미끄러지듯 이동하기",
        "gui.howtos.cartoon-network.step_CNpicksprite": "쫓아갈 물건 고르기",
        "gui.howtos.cartoon-network.step_CNcollect": "물건 모으기",
        "gui.howtos.cartoon-network.step_CNvariable": "점수 변수 만들기 ",
        "gui.howtos.cartoon-network.step_CNscore": "점수 저장하기",
        "gui.howtos.cartoon-network.step_CNbackdrop": "레벨 업: 배경 바꾸기",
        "gui.howtos.videosens.name": "비디오 감지",
        "gui.howtos.videosens.step_addextension": "확장 기능 추가하기",
        "gui.howtos.videosens.step_pet": "고양이 쓰다듬기",
        "gui.howtos.videosens.step_animate": "애니메이션으로 만들기",
        "gui.howtos.videosens.step_pop": "풍선 터트리기",
        "gui.howtos.talking": "Talking Tales",
        "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
        "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
        "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
        "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
        "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
        "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
        "gui.howtos.talking.step_talesMoveAround": "Move Around",
        "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
        "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
        "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
        "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
        "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
        "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
        "gui.howtos.add-sprite.name": "스프라이트 추가하기",
        "gui.howtos.add-sprite.step_addSprite": "스프라이트 추가하기",
        "gui.howtos.add-a-backdrop.name": "배경 추가하기",
        "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
        "gui.howtos.move-around-with-arrow-keys.name": "방향키 사용하기",
        "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
        "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
        "gui.howtos.change-size.name": "크기 바꾸기",
        "gui.howtos.change-size.step_changeSize": "Change Size",
        "gui.howtos.glide-around.name": "미끄러지듯 이동하기",
        "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
        "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
        "gui.howtos.spin-video.name": "회전하게 만들기",
        "gui.howtos.change-size.step_spinTurn": "Turn",
        "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
        "gui.howtos.record-a-sound.name": "소리 녹음하기",
        "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
        "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
        "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
        "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
        "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
        "gui.howtos.hide-and-show.name": "숨기기와 보이기",
        "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
        "gui.howtos.switch-costume.name": "스프라이트를 애니메이션으로 만들기",
        "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
        "gui.extension.music.name": "음악",
        "gui.extension.music.description": "악기와 타악기를 연주하세요.",
        "gui.extension.pen.name": "펜",
        "gui.extension.pen.description": "스프라이트를 사용하여 그려 보세요. ",
        "gui.extension.videosensing.name": "비디오 감지",
        "gui.extension.videosensing.description": "카메라를 이용하여 움직임을 감지해 보세요.",
        "gui.extension.text2speech.name": "텍스트 음성 변환(TTS)",
        "gui.extension.text2speech.description": "프로젝트가 말을 하도록 만들어 보세요.",
        "gui.extension.translate.name": "번역",
        "gui.extension.translate.description": "텍스트를 여러 가지 언어로 번역해 보세요.",
        "gui.extension.makeymakey.description": "무엇이든지 키보드 자판으로 만들어 보세요.",
        "gui.extension.microbit.description": "프로젝트를 세계와 연결해 보세요.",
        "gui.extension.microbit.connectingMessage": "연결 중",
        "gui.extension.ev3.description": "감지하고 반응하는 로봇 등을 만들어 보세요.",
        "gui.extension.ev3.connectingMessage": "연결 중입니다. EV3의 pin이 1234로 설정되었는지 확인하세요.",
        "gui.extension.boost.description": "Bring robotic creations to life.",
        "gui.extension.boost.connectingMessage": "Connecting",
        "gui.extension.wedo2.description": "모터 및 센서를 이용하여 만들어 보세요. ",
        "gui.extension.wedo2.connectingMessage": "연결 중",
        "gui.extension.gdxfor.description": "Sense push, pull, motion, and spin.",
        "gui.extension.gdxfor.connectingMessage": "Connecting",
        "gui.libraryTags.all": "모두",
        "gui.libraryTags.animals": "동물",
        "gui.libraryTags.dance": "댄스",
        "gui.libraryTags.effects": "효과",
        "gui.libraryTags.fantasy": "판타지",
        "gui.libraryTags.fashion": "패션",
        "gui.libraryTags.food": "음식",
        "gui.libraryTags.indoors": "실내",
        "gui.libraryTags.loops": "반복",
        "gui.libraryTags.music": "음악",
        "gui.libraryTags.notes": "음표",
        "gui.libraryTags.outdoors": "실외",
        "gui.libraryTags.patterns": "패턴",
        "gui.libraryTags.people": "사람들",
        "gui.libraryTags.percussion": "타악기",
        "gui.libraryTags.space": "우주",
        "gui.libraryTags.sports": "스포츠",
        "gui.libraryTags.underwater": "바닷속",
        "gui.libraryTags.voice": "목소리",
        "gui.libraryTags.wacky": "엉뚱한 소리",
        "gui.libraryTags.animation": "애니메이션",
        "gui.libraryTags.art": "예술",
        "gui.libraryTags.games": "게임",
        "gui.libraryTags.stories": "이야기",
        "gui.libraryTags.letters": "글자",
        "gui.opcodeLabels.direction": "방향",
        "gui.opcodeLabels.xposition": "x 좌표",
        "gui.opcodeLabels.yposition": "y 좌표",
        "gui.opcodeLabels.size": "크기",
        "gui.opcodeLabels.costumename": "모양 이름",
        "gui.opcodeLabels.costumenumber": "모양 번호",
        "gui.opcodeLabels.backdropname": "배경 이름",
        "gui.opcodeLabels.backdropnumber": "배경 번호",
        "gui.opcodeLabels.volume": "음량",
        "gui.opcodeLabels.tempo": "빠르기",
        "gui.opcodeLabels.answer": "대답",
        "gui.opcodeLabels.loudness": "음량",
        "gui.opcodeLabels.username": "사용자 이름",
        "gui.opcodeLabels.year": "년",
        "gui.opcodeLabels.month": "월",
        "gui.opcodeLabels.date": "일",
        "gui.opcodeLabels.dayofweek": "요일",
        "gui.opcodeLabels.hour": "시",
        "gui.opcodeLabels.minute": "분",
        "gui.opcodeLabels.second": "초",
        "gui.opcodeLabels.timer": "타이머",
        "gui.projectLoader.loadError": "The project file that was selected failed to load.",
        "gui.projectLoader.extremeProjectOnly": "이 파일은 eXtreme 모듈용 프로젝트입니다. 상단의 모듈 선택 메뉴에서 eXtreme으로 변경한 뒤 다시 불러와 주세요.",
        "gui.projectLoader.xlineProjectOnly": "이 파일은 X-LINE 모듈용 프로젝트입니다. 상단의 모듈 선택 메뉴에서 X-LINE으로 변경한 뒤 다시 불러와 주세요.",
        "gui.projectLoader.compatibilityModalTitle": "이 파일은 여기서 열 수 없습니다.",
        "gui.projectLoader.compatibilityModalConfirm": "확인",
        "gui.sharedMessages.backdrop": "배경 {index}",
        "gui.sharedMessages.costume": "모양 {index}",
        "gui.sharedMessages.sprite": "스프라이트 {index}",
        "gui.sharedMessages.pop": "팝",
        "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
        "gui.sharedMessages.loadFromComputerTitle": "컴퓨터에서 가져오기",
        "gui.theme.default": "Original",
        "gui.theme.dark": "Dark",
        "gui.theme.highContrast": "고대비",
        "gui.gui.defaultProjectTitle": "스크래치 프로젝트",
        "boost.color.any": "any color",
        "boost.color.black": "black",
        "boost.color.blue": "blue",
        "boost.color.green": "green",
        "boost.color.red": "red",
        "boost.color.white": "white",
        "boost.color.yellow": "yellow",
        "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
        "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
        "boost.motorDirection.backward": "that way",
        "boost.motorDirection.forward": "this way",
        "boost.motorDirection.reverse": "reverse",
        "boost.motorOff": "turn motor [MOTOR_ID] off",
        "boost.motorOn": "turn motor [MOTOR_ID] on",
        "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
        "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
        "boost.seeingColor": "seeing [COLOR] brick?",
        "boost.setLightHue": "set light color to [HUE]",
        "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
        "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
        "boost.tiltDirection.any": "any",
        "boost.tiltDirection.down": "down",
        "boost.tiltDirection.left": "left",
        "boost.tiltDirection.right": "right",
        "boost.tiltDirection.up": "up",
        "boost.whenColor": "when [COLOR] brick seen",
        "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
        "ev3.beepNote": "[TIME] 초 동안 [NOTE] 번 음 울리기",
        "ev3.buttonPressed": " [PORT] 번 버튼이 눌러졌는가?",
        "ev3.getBrightness": "밝기",
        "ev3.getDistance": "거리",
        "ev3.getMotorPosition": "모터 [PORT] 위치",
        "ev3.motorSetPower": "[PORT] 모터 강도를 [POWER] %로 정하기",
        "ev3.motorTurnClockwise": "[PORT] 모터를 [TIME] 초 동안 이쪽으로 돌리기",
        "ev3.motorTurnCounterClockwise": "[PORT] 모터를 [TIME] 초 동안 저쪽으로 돌리기",
        "ev3.whenBrightnessLessThan": "밝기 <  [DISTANCE]일 때",
        "ev3.whenButtonPressed": "[PORT] 번 버튼이 눌러졌을 때",
        "ev3.whenDistanceLessThan": "거리 < [DISTANCE]일 때",
        "gdxfor.getAcceleration": "acceleration [DIRECTION]",
        "gdxfor.getForce": "force",
        "gdxfor.getSpin": "spin speed [DIRECTION]",
        "gdxfor.getTilt": "tilt angle [TILT]",
        "gdxfor.isFreeFalling": "falling?",
        "gdxfor.isTilted": "tilted [TILT]?",
        "gdxfor.pulled": "pulled",
        "gdxfor.pushed": "pushed",
        "gdxfor.shaken": "shaken",
        "gdxfor.startedFalling": "started falling",
        "gdxfor.tiltDirectionMenu.any": "any",
        "gdxfor.tiltDirectionMenu.back": "back",
        "gdxfor.tiltDirectionMenu.front": "front",
        "gdxfor.tiltDirectionMenu.left": "left",
        "gdxfor.tiltDirectionMenu.right": "right",
        "gdxfor.turnedFaceDown": "turned face down",
        "gdxfor.turnedFaceUp": "turned face up",
        "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
        "gdxfor.whenGesture": "when [GESTURE]",
        "gdxfor.whenTilted": "when tilted [TILT]",
        "makeymakey.downArrow": "down arrow",
        "makeymakey.downArrowShort": "아래쪽",
        "makeymakey.leftArrow": "left arrow",
        "makeymakey.leftArrowShort": "왼쪽",
        "makeymakey.rightArrow": "right arrow",
        "makeymakey.rightArrowShort": "오른쪽",
        "makeymakey.spaceKey": "스페이스",
        "makeymakey.upArrow": "up arrow",
        "makeymakey.upArrowShort": "위쪽",
        "makeymakey.whenKeyPressed": "[KEY] 키를 눌렀을 때",
        "makeymakey.whenKeysPressedInOrder": "[SEQUENCE] 키를 순서대로 눌렀을 때",
        "microbit.buttonsMenu.any": "아무",
        "microbit.clearDisplay": "화면 지우기",
        "microbit.defaultTextToDisplay": "Hello!",
        "microbit.displaySymbol": "[MATRIX] 보여주기",
        "microbit.displayText": "글자 [TEXT] 보여주기",
        "microbit.gesturesMenu.jumped": "점프하였을",
        "microbit.gesturesMenu.moved": "움직일",
        "microbit.gesturesMenu.shaken": "흔들어졌을",
        "microbit.isButtonPressed": "[BTN] 버튼이 눌려졌는가?",
        "microbit.isTilted": "[DIRECTION] 방향으로 기울어졌는가?",
        "microbit.pinStateMenu.off": "끄기",
        "microbit.pinStateMenu.on": "켜기",
        "microbit.tiltAngle": "[DIRECTION] 방향으로 기울어진 각도",
        "microbit.tiltDirectionMenu.any": "아무",
        "microbit.tiltDirectionMenu.back": "뒤쪽",
        "microbit.tiltDirectionMenu.front": "앞쪽",
        "microbit.tiltDirectionMenu.left": "왼쪽",
        "microbit.tiltDirectionMenu.right": "오른쪽",
        "microbit.whenButtonPressed": "[BTN] 버튼이 눌러졌을 때",
        "microbit.whenGesture": "[GESTURE] 때",
        "microbit.whenPinConnected": "[PIN]번 핀이 연결되었을 때",
        "microbit.whenTilted": "[DIRECTION] 방향으로 기울어졌을 때",
        "music.categoryName": "음악",
        "music.changeTempo": "빠르기를 [TEMPO] 만큼 바꾸기",
        "music.drumBass": "(2) 베이스 드럼",
        "music.drumBongo": "(13) 봉고",
        "music.drumCabasa": "(15) 카바사",
        "music.drumClaves": "(9) 클라베",
        "music.drumClosedHiHat": "(6) 닫힌 하이햇",
        "music.drumConga": "(14) 콩가",
        "music.drumCowbell": "(11) 카우벨 ",
        "music.drumCrashCymbal": "(4) 크래시 심벌",
        "music.drumCuica": "(18) 쿠이카 ",
        "music.drumGuiro": "(16) 귀로 ",
        "music.drumHandClap": "(8) 박수",
        "music.drumOpenHiHat": "(5) 열린 하이햇",
        "music.drumSideStick": "(3) 사이드 스틱",
        "music.drumSnare": "(1) 스네어 드럼 ",
        "music.drumTambourine": "(7) 탬버린",
        "music.drumTriangle": "(12) 트라이앵글 ",
        "music.drumVibraslap": "(17) 비브라슬랩 ",
        "music.drumWoodBlock": "(10) 나무 블록",
        "music.getTempo": "빠르기",
        "music.instrumentBass": "(6) 베이스",
        "music.instrumentBassoon": "(14) 바순",
        "music.instrumentCello": "(8) 첼로 ",
        "music.instrumentChoir": "(15) 합창단 ",
        "music.instrumentClarinet": "(10) 클라리넷 ",
        "music.instrumentElectricGuitar": "(5) 전자 기타 ",
        "music.instrumentElectricPiano": "(2) 전자 피아노 ",
        "music.instrumentFlute": "(12) 플루트 ",
        "music.instrumentGuitar": "(4) 기타",
        "music.instrumentMarimba": "(19) 마림바 ",
        "music.instrumentMusicBox": "(17) 뮤직 박스",
        "music.instrumentOrgan": "(3) 오르간",
        "music.instrumentPiano": "(1) 피아노",
        "music.instrumentPizzicato": "(7) 피치카토 ",
        "music.instrumentSaxophone": "(11) 색소폰 ",
        "music.instrumentSteelDrum": "(18) 스틸 드럼 ",
        "music.instrumentSynthLead": "(20) 신드 리드",
        "music.instrumentSynthPad": "(21) 신드 패드 ",
        "music.instrumentTrombone": "(9) 트럼본",
        "music.instrumentVibraphone": "(16) 비브라폰",
        "music.instrumentWoodenFlute": "(13) 나무 플루트 ",
        "music.midiPlayDrumForBeats": "[DRUM]번 타악기를 [BEATS] 박자로 연주하기",
        "music.midiSetInstrument": "악기를 [INSTRUMENT](으)로 정하기",
        "music.playDrumForBeats": "[DRUM]번 타악기를 [BEATS] 박자로 연주하기",
        "music.playNoteForBeats": "[NOTE]번 음을 [BEATS] 박자로 연주하기",
        "music.restForBeats": "[BEATS] 박자 쉬기 ",
        "music.setInstrument": "악기를 [INSTRUMENT](으)로 정하기",
        "music.setTempo": "빠르기를 [TEMPO](으)로 정하기",
        "pen.categoryName": "펜",
        "pen.changeColorParam": "펜 [COLOR_PARAM]을(를) [VALUE]만큼 바꾸기",
        "pen.changeHue": "펜 색깔을 [HUE]만큼 바꾸기",
        "pen.changeShade": "펜 명암을 [SHADE] 만큼 바꾸기 ",
        "pen.changeSize": "펜 굵기를 [SIZE] 만큼 바꾸기",
        "pen.clear": "모두 지우기",
        "pen.colorMenu.brightness": "명도",
        "pen.colorMenu.color": "색깔",
        "pen.colorMenu.saturation": "채도 ",
        "pen.colorMenu.transparency": "투명도",
        "pen.penDown": "펜 내리기",
        "pen.penUp": "펜 올리기",
        "pen.setColor": "펜 색깔을 [COLOR](으)로 정하기 ",
        "pen.setColorParam": "펜 [COLOR_PARAM]을(를) [VALUE](으)로 정하기",
        "pen.setHue": "펜 색깔을 [HUE](으)로 정하기",
        "pen.setShade": "펜 명암을 [SHADE](으)로 정하기 ",
        "pen.setSize": "펜 굵기를 [SIZE](으)로 정하기",
        "pen.stamp": "도장찍기",
        "speech.defaultWhenIHearValue": "시작합시다",
        "speech.extensionName": "음성 인식",
        "speech.listenAndWait": "듣고 기다리기",
        "speech.speechReporter": "인식된 말",
        "speech.whenIHear": "[PHRASE] 이(가) 들릴 때",
        "text2speech.alto": "중고음",
        "text2speech.categoryName": "Text to Speech",
        "text2speech.defaultTextToSpeak": "안녕 ",
        "text2speech.giant": "저음",
        "text2speech.kitten": "고양이",
        "text2speech.setLanguageBlock": "언어를 [LANGUAGE]로 정하기",
        "text2speech.setVoiceBlock": "음성을 [VOICE]로 정하기",
        "text2speech.speakAndWaitBlock": "[WORDS] 말하기",
        "text2speech.squeak": "고음",
        "text2speech.tenor": "중저음",
        "translate.categoryName": "번역",
        "translate.defaultTextToTranslate": "안녕 ",
        "translate.translateBlock": "[WORDS]을(를) [LANGUAGE]로 번역하기",
        "translate.viewerLanguage": "언어",
        "videoSensing.categoryName": "비디오 감지",
        "videoSensing.direction": "방향",
        "videoSensing.motion": "동작",
        "videoSensing.off": "끄기",
        "videoSensing.on": "켜기",
        "videoSensing.onFlipped": "뒤집힌 상태로 켜기",
        "videoSensing.setVideoTransparency": "비디오 투명도를 [TRANSPARENCY] (으)로 정하기",
        "videoSensing.sprite": "스프라이트",
        "videoSensing.stage": "무대 ",
        "videoSensing.videoOn": "비디오 [ATTRIBUTE]에 대한 [SUBJECT]에서의 관찰값",
        "videoSensing.videoToggle": "비디오 [VIDEO_STATE]",
        "videoSensing.whenMotionGreaterThan": "비디오 동작 > [REFERENCE]일 때 ",
        "wedo2.getDistance": "거리",
        "wedo2.getTiltAngle": "[TILT_DIRECTION] 방향으로 기울어진 각도",
        "wedo2.isTilted": "[TILT_DIRECTION_ANY] 방향으로 기울어졌는가?",
        "wedo2.motorDirection.backward": "저쪽",
        "wedo2.motorDirection.forward": "이쪽",
        "wedo2.motorDirection.reverse": "반대쪽",
        "wedo2.motorId.a": "모터 A",
        "wedo2.motorId.all": "모든 모터",
        "wedo2.motorId.b": "모터 B",
        "wedo2.motorId.default": "모터",
        "wedo2.motorOff": "[MOTOR_ID] 끄기",
        "wedo2.motorOn": "[MOTOR_ID] 켜기",
        "wedo2.motorOnFor": "[DURATION] 초 동안 [MOTOR_ID] 켜기",
        "wedo2.playNoteFor": "[NOTE] 번 음을 [DURATION]초 간 연주하기",
        "wedo2.setLightHue": "빛의 색을  [HUE]로 정하기",
        "wedo2.setMotorDirection": "[MOTOR_ID]의 방향을 [MOTOR_DIRECTION]으로 정하기",
        "wedo2.startMotorPower": "[MOTOR_ID] 모터 강도를 [POWER]로 정하기",
        "wedo2.tiltDirection.any": "아무",
        "wedo2.tiltDirection.down": "아래쪽",
        "wedo2.tiltDirection.left": "왼쪽",
        "wedo2.tiltDirection.right": "오른쪽",
        "wedo2.tiltDirection.up": "위쪽",
        "wedo2.whenDistance": "거리 [OP] [REFERENCE] 일 때",
        "wedo2.whenTilted": "[TILT_DIRECTION_ANY] 방향으로 기울일 때",
        "paint.paintEditor.hue": "색상",
        "paint.paintEditor.saturation": "채도",
        "paint.paintEditor.brightness": "명도",
        "paint.paintEditor.costume": "모양",
        "paint.paintEditor.group": "그룹화 적용",
        "paint.paintEditor.ungroup": "그룹화 해제",
        "paint.paintEditor.undo": "되돌리기",
        "paint.paintEditor.redo": "재시도",
        "paint.paintEditor.forward": "앞으로",
        "paint.paintEditor.backward": "뒤로",
        "paint.paintEditor.front": "맨 앞으로",
        "paint.paintEditor.back": "맨 뒤로",
        "paint.paintEditor.more": "기타",
        "paint.modeTools.brushSize": "크기",
        "paint.modeTools.eraserSize": "지우개 크기",
        "paint.modeTools.copy": "복사",
        "paint.modeTools.paste": "붙이기",
        "paint.modeTools.delete": "삭제",
        "paint.modeTools.curved": "굽은 모양",
        "paint.modeTools.pointed": "꺾인 모양",
        "paint.modeTools.thickness": "굵기",
        "paint.modeTools.flipHorizontal": "좌우 뒤집기",
        "paint.modeTools.flipVertical": "상하 뒤집기",
        "paint.modeTools.filled": "채우기",
        "paint.modeTools.outlined": "윤곽선",
        "paint.paintEditor.bitmap": "비트맵으로 바꾸기",
        "paint.paintEditor.vector": "벡터로 바꾸기",
        "paint.paintEditor.fill": "채우기 색",
        "paint.paintEditor.stroke": "윤곽선 색",
        "paint.brushMode.brush": "붓",
        "paint.eraserMode.eraser": "지우개",
        "paint.fillMode.fill": "채우기 색",
        "paint.lineMode.line": "선",
        "paint.ovalMode.oval": "원",
        "paint.rectMode.rect": "직사각형",
        "paint.reshapeMode.reshape": "형태 고치기",
        "paint.roundedRectMode.roundedRect": "모서리가 둥근 직사각형",
        "paint.selectMode.select": "선택",
        "paint.textMode.text": "텍스트",
        "paint.colorPicker.swap": "바꾸기"
    }
};

export default editorMessages;
